import { clientApi } from 'api';

export const deleteFilterProduct = (isServer = false) => async (id: string) => {
  await clientApi.delete<string>(`/filter-products/${id}`);
};
